import { useId } from "react";

function SliderInput({
    value,
    handleSliderChange,
    getColorForScore
 }) {
  const id = useId().replace(/:/g, "");
  const color = getColorForScore(value);

  // percent filled (0–100)
  const pct = (value / 10) * 100;

  return (
    <>
      <style>{`
        .slider-container-${id} {
          height: 400px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        @media (max-width: 768px) {
          .slider-container-${id} {
            height: 300px;
          }

          .slider-${id} {
            width: 300px !important;
          }
        }

        .slider-${id} {
          -webkit-appearance: none;
          appearance: none;

          /* VISUAL HEIGHT after rotate */
          width: 400px;

          /* VISUAL THICKNESS after rotate */
          height: 0.75rem;

          /* dynamic filled track */
          background: linear-gradient(
            to right,
            ${color} 0%,
            ${color} ${pct}%,
            #e5e7eb ${pct}%,
            #e5e7eb 100%
          );

          border-radius: 0.375rem;

          transform: rotate(-90deg);
          cursor: pointer;
        }

        .slider-${id}::-webkit-slider-runnable-track {
          background: transparent;
          height: 0.75rem;
          border-radius: 0.375rem;
        }

        .slider-${id}::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 2rem;
          height: 2rem;
          background: ${color};
          border-radius: 50%;
          border: 0.5rem solid transparent;
          margin-top: -0.625rem;
          cursor: grab;
        }

        .slider-${id}::-webkit-slider-thumb:active {
          cursor: grabbing;
        }

        .slider-${id}::-moz-range-track {
          background: transparent;
          height: 0.75rem;
          border-radius: 0.375rem;
        }

        .slider-${id}::-moz-range-progress {
          background: ${color};
          height: 0.75rem;
          border-radius: 0.375rem;
        }

        .slider-${id}::-moz-range-thumb {
          width: 2rem;
          height: 2rem;
          background: ${color};
          border-radius: 50%;
          border: 0.5rem solid transparent;
          cursor: grab;
        }

        .slider-${id}::-moz-range-thumb:active {
          cursor: grabbing;
        }
      `}</style>

      <div className={`slider-container-${id}`}>
        <input
          type="range"
          min="0"
          max="10"
          step="0.1"
          value={value}
          onChange={handleSliderChange}
          className={`slider-${id}`}
        />
      </div>
    </>
  );
}

export default SliderInput;